/**
  * @prop --transition: The transition to use for the opening/closing animation. Default: .3s ease-in-out.
  */

lg-accordion-item {
  --transition: .3s ease-in-out;

  display: block;
  box-sizing: border-box;

  details {
    overflow: hidden;
    transition: height var(--transition);
  }

  summary {
    // remove default arrow
    display: block;
    // make sure no margins leak
    overflow: hidden;

    &::-webkit-details-marker {
      // Safari needs special treatment...
      display: none;
    }
  }

  .content {
    // make sure no margins leak
    overflow: hidden;
  }
}
